import React, { useState, useEffect, useRef } from 'react';
import { 
  Autocomplete, 
  TextField, 
  Box,
  Popover,
  IconButton,
  Typography,
  CircularProgress,
  InputAdornment,
  Chip,
  Stack
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../../redux/permissionsSlice';
import SearchIcon from '@mui/icons-material/Search';
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';
import LanguageIcon from '@mui/icons-material/Language';

const SearchBoxWithVoice = () => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isListening, setIsListening] = useState(false);
  const [transcript, setTranscript] = useState('');
  const [recognition, setRecognition] = useState(null);
  const [browserSupport, setBrowserSupport] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [suggestedModules, setSuggestedModules] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const permissions = useSelector(selectPermissions);
  
  // SpeechRecognition initialization
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  const SpeechGrammarList = window.SpeechGrammarList || window.webkitSpeechGrammarList;

  // Module options with ALL your modules
  const moduleOptions = [
    { label: 'Dashboard', route: '/dashboard' },
    { label: 'Company Master', route: '/masters/companytable' },
    { label: 'User Master', route: '/userMasterTable' },
    { label: 'Employee Master', route: '/employeetable' },
    { label: 'Employee Type Master', route: '/employeetypetable' },
    { label: 'Designation Master', route: '/designationtable' },
    { label: 'Payment Plan Master', route: '/roomPlanTable' },
    { label: 'Promocode Master', route: '/promotable' },
    { label: 'Coupon Authority', route: '/couponAuthorityTable' },
    { label: 'Coupon Master', route: '/generate-coupon-table' },
    { label: 'Topup Master', route: '/Topup_Table' },
    { label: 'Transport Plan', route: '/transport-plan-table' },
    { label: 'Mess Plan', route: '/mess-plan-table' },
    { label: 'Property Master', route: '/propertytable' },
    { label: 'Room Master', route: '/room-master-table' },
    { label: 'Bed Master', route: '/roomBednumbertable' },
    { label: 'Wing Master', route: '/wingtable' },
    { label: 'Floor Master', route: '/floortable' },
    { label: 'PropertyType Master', route: '/propertyTypetable' },
    { label: 'Room Type Master', route: '/roomTypetable' },
    { label: 'BedType Master', route: '/roomBedTypetable' },
    { label: 'Room View', route: '/roomViewtable' },
    { label: 'Facilities Master', route: '/facilitiesmastertable' },
    { label: 'Amenities Master', route: '/amenitytable' },
    { label: 'Common Area', route: '/commonareatable' },
    { label: 'Generate Calender', route: '/generatecalender' },
    { label: 'Resident Master', route: '/masters/residenttable' },
    { label: 'Vendors & Creditors', route: '/partytable' },
    { label: 'Corporate Master', route: '/corporateTable' },
    { label: 'Institute Master', route: '/instituteMasterTable' },
    { label: 'Course Master', route: '/coursetable' },
    { label: 'Semester Master', route: '/semestertable' },
    { label: 'Source Master', route: '/sourceMstTable' },
    { label: 'Bank Master', route: '/bank-table' },
    { label: 'Relation Master', route: '/relation-table' },
    { label: 'Class Master', route: '/classtable' },
    { label: 'Rating Master', route: '/ratingtable' },
    { label: 'Category Master', route: '/categorytable' },
    { label: 'Group Master', route: '/grptable' },
    { label: 'SubGroup Master', route: '/subgrptable' },
    { label: 'Assets/Store Master', route: '/assettable' },
    { label: 'Unit Master', route: '/unittable' },
    { label: 'Main Group', route: '/maingrptable' },
    { label: 'Groups', route: '/groupmsttable' },
    { label: 'SubGroups', route: '/subgrpmsttable' },
    { label: 'Ledgers', route: '/ledgertable' },
    { label: 'Other Charges', route: '/otherchargestable' },
    { label: 'Ticket Category', route: '/ticket-category-table' },
    { label: 'Warden/Vendor Allocation', route: '/warden-allocation-table' },
    { label: 'Ticket SubCategory', route: '/ticket-subcategory-table' },
    { label: 'Service/Complaint Master', route: '/service-table' },
    { label: 'Ticket Status', route: '/ticket-status' },
    { label: 'House Keeping Type Master', route: '/hk-typetable' },
    { label: 'Shift Master', route: '/masters/shift-table' },
    { label: 'Module Rights', route: '/module-rights-table' },
    { label: 'User Rights', route: '/userpermission' },
    { label: 'Audit Trail', route: '/audit-report' },
    { label: 'Email Configuration', route: '/emailconfig-table' },
    { label: 'Payment Gateway Configuration', route: '/paymentGatewayConfigTable' },
    { label: 'Send Email', route: '/send-email' },
    { label: 'Enquiry', route: '/enquirytable' },
    { label: 'Follow-Ups', route: '/TableFollowUp' },
    { label: 'Booking', route: '/bookingtable' },
    { label: 'Booking Confirmation', route: '/BookingConfirmTable' },
    { label: 'Check-In', route: '/enquiry/checkintable' },
    { label: 'Check-Out', route: '/enquiry/CheckoutTable' },
    { label: 'Payment Advice', route: '/advicegeneratetable' },
    { label: 'Receipt Voucher', route: '/receipt-table' },
    { label: 'Refund', route: '/enquiry/refund' },
    { label: 'Plan Calculation', route: '/calculation' },
    { label: 'Transaction TopUp', route: '/trntopuptable' },
    { label: 'Ticket Dashboard', route: '/raise-tkt-dashboard' },
    { label: 'Raise Service Ticket', route: '/raise-service-tkt' },
    { label: 'Task Assignment', route: '/task-assignment' },
    { label: 'Task Acceptance', route: '/task-acceptance' },
    { label: 'MPR Calendor', route: '/operations/menpower-calendar' },
    { label: 'Inward GRN', route: '/inventory/GRNTable' },
    { label: 'Asset Allocation', route: '/assetallocationtable' },
    { label: 'Asset Transfer', route: '/assettransfertable' },
    { label: 'Bed Reports', route: '/bedreporttable' },
    { label: 'Booking details', route: '/reports/bookingdetails' },
    { label: 'Booking Summary', route: '/Booking' },
    { label: 'User & Permission', route: '/userpermission' },
    { label: 'New Calender', route: '/newcalender' },
    { label: 'Payment Request Log', route: '/paymentreqlog' },
    { label: 'Daily Summary Report', route: '/dailysummaryreport' },
    { label: 'Month Wise Bed Availability', route: '/bedcategorysummary' },
    { label: 'Bed Report Calendar', route: '/bedreporttable' },
    { label: 'Resident Account', route: '/reports/resident-account' },
    { label: 'Booking Report', route: '/booking-report' },
    { label: 'Outstanding Report', route: '/outstanding' },
    { label: 'Resident Wise Details', route: '/residentwisedtl' },
  ].map(module => ({
    ...module,
    // Add Indian variations for each module
    indianVariations: generateIndianVariations(module.label),
    // Add lowercase version for case-insensitive matching
    lowercaseLabel: module.label.toLowerCase()
  }));

  // Function to generate Indian variations
  function generateIndianVariations(moduleName) {
    const variations = new Set();
    const lowerName = moduleName.toLowerCase();
    
    // Add lowercase version
    variations.add(lowerName);
    
    // Common Indian mispronunciations
    const transformations = [
      // "Room" variations
      (str) => str.replace(/room/gi, 'rum'),
      (str) => str.replace(/room/gi, 'rooom'),
      (str) => str.replace(/room/gi, 'rom'),
      (str) => str.replace(/room/gi, 'roomm'),
      
      // "Property" variations
      (str) => str.replace(/property/gi, 'proparty'),
      (str) => str.replace(/property/gi, 'properti'),
      (str) => str.replace(/property/gi, 'propperty'),
      (str) => str.replace(/property/gi, 'propety'),
      
      // "Master" variations
      (str) => str.replace(/master/gi, 'mastar'),
      (str) => str.replace(/master/gi, 'muster'),
      (str) => str.replace(/master/gi, 'mastr'),
      
      // "Dashboard" variations
      (str) => str.replace(/dashboard/gi, 'dashbord'),
      (str) => str.replace(/dashboard/gi, 'dash board'),
      (str) => str.replace(/dashboard/gi, 'deshboard'),
      
      // "Booking" variations
      (str) => str.replace(/booking/gi, 'bokking'),
      (str) => str.replace(/booking/gi, 'bookking'),
      (str) => str.replace(/booking/gi, 'bookin'),
      
      // "Report" variations
      (str) => str.replace(/report/gi, 'riport'),
      (str) => str.replace(/report/gi, 'reporrt'),
      (str) => str.replace(/report/gi, 'repoart'),
      
      // "Payment" variations
      (str) => str.replace(/payment/gi, 'paymant'),
      (str) => str.replace(/payment/gi, 'paymment'),
      (str) => str.replace(/payment/gi, 'payement'),
      
      // Remove spaces for "Room Master" -> "RoomMaster"
      (str) => str.replace(/\s+/g, ''),
      (str) => str.replace(/\s+/g, ' ').trim(),
      
      // Handle single/double letters
      (str) => str.replace(/([a-z])\1/gi, '$1'),
      (str) => str.replace(/([bcdfghjklmnpqrstvwxyz])/gi, '$1$1'),
    ];
    
    // Generate variations
    transformations.forEach(transform => {
      try {
        const variation = transform(lowerName);
        if (variation && variation !== lowerName) {
          variations.add(variation);
        }
      } catch (e) {
        // Ignore errors
      }
    });
    
    // Add "Room Master" specific variations
    if (lowerName.includes('room') && lowerName.includes('master')) {
      variations.add('rum mastar');
      variations.add('rum master');
      variations.add('room mastar');
      variations.add('rom master');
      variations.add('rooom master');
      variations.add('roommastar');
      variations.add('rummastar');
      variations.add('rommastar');
    }
    
    // Add "Property Master" specific variations
    if (lowerName.includes('property') && lowerName.includes('master')) {
      variations.add('proparty mastar');
      variations.add('proparty master');
      variations.add('property mastar');
      variations.add('properti mastar');
      variations.add('propperty master');
      variations.add('propety master');
      variations.add('propartymastar');
      variations.add('propertimastar');
    }
    
    return Array.from(variations);
  }

  // Simple string similarity function (works for Indian accent)
  function calculateSimilarity(str1, str2) {
    const s1 = str1.toLowerCase();
    const s2 = str2.toLowerCase();
    
    // Exact match (case-insensitive)
    if (s1 === s2) return 1.0;
    
    // Check if one contains the other
    if (s1.includes(s2) || s2.includes(s1)) {
      return 0.9;
    }
    
    // Check Indian variations
    const module = moduleOptions.find(m => 
      m.indianVariations && m.indianVariations.some(variation => 
        variation === s1 || variation === s2
      )
    );
    
    if (module) {
      return 0.85;
    }
    
    // Calculate Levenshtein distance
    const len1 = s1.length;
    const len2 = s2.length;
    const maxLen = Math.max(len1, len2);
    
    if (maxLen === 0) return 1.0;
    
    const matrix = [];
    for (let i = 0; i <= len1; i++) {
      matrix[i] = [i];
    }
    for (let j = 0; j <= len2; j++) {
      matrix[0][j] = j;
    }
    
    for (let i = 1; i <= len1; i++) {
      for (let j = 1; j <= len2; j++) {
        const cost = s1[i - 1] === s2[j - 1] ? 0 : 1;
        matrix[i][j] = Math.min(
          matrix[i - 1][j] + 1,     // deletion
          matrix[i][j - 1] + 1,     // insertion
          matrix[i - 1][j - 1] + cost  // substitution
        );
      }
    }
    
    const distance = matrix[len1][len2];
    return 1 - (distance / maxLen);
  }

  useEffect(() => {
    const checkBrowserSupport = () => {
      if (SpeechRecognition) {
        setBrowserSupport(true);
        
        try {
          const recognitionInstance = new SpeechRecognition();
          
          // Set language to Indian English
          recognitionInstance.lang = 'en-IN';
          recognitionInstance.continuous = false;
          recognitionInstance.interimResults = false;
          recognitionInstance.maxAlternatives = 3;
          
          // DO NOT set grammars - that was causing the error
          // Remove this line: recognitionInstance.grammars = null;
          
          recognitionInstance.onresult = (event) => {
            const results = event.results[0];
            let bestTranscript = '';
            
            // Get the transcript from the first alternative
            if (results && results[0]) {
              bestTranscript = results[0].transcript;
            }
            
            setTranscript(bestTranscript);
            handleVoiceResult(bestTranscript);
          };
          
          recognitionInstance.onerror = (event) => {
            console.error('Speech recognition error:', event.error);
            setIsListening(false);
            setIsProcessing(false);
            
            switch(event.error) {
              case 'no-speech':
                setErrorMessage('No speech detected. Please speak clearly.');
                break;
              case 'audio-capture':
                setErrorMessage('Microphone not found. Please check your microphone.');
                break;
              case 'not-allowed':
                setErrorMessage('Microphone permission denied. Please allow microphone access.');
                break;
              default:
                setErrorMessage('Voice recognition failed. Please try again.');
            }
            
            setTimeout(() => setErrorMessage(''), 5000);
          };
          
          recognitionInstance.onend = () => {
            setIsListening(false);
            setIsProcessing(false);
          };
          
          setRecognition(recognitionInstance);
        } catch (error) {
          console.error('Error initializing speech recognition:', error);
          setBrowserSupport(false);
          setErrorMessage('Speech recognition initialization failed.');
        }
      } else {
        setBrowserSupport(false);
        setErrorMessage('Voice search not supported in this browser. Try Chrome or Edge.');
      }
    };
    
    checkBrowserSupport();
    
    return () => {
      if (recognition) {
        try {
          recognition.abort();
        } catch (e) {
          // Ignore abort errors
        }
      }
    };
  }, []);

  // Get filtered modules based on permissions
  const getFilteredModuleOptions = () => {
    if (!permissions || permissions.length === 0) {
      return moduleOptions;
    }
    
    return moduleOptions.filter(option => {
      const modulePermission = permissions.find(p => p.ModuleName === option.label);
      return modulePermission && (
        modulePermission.AddRec === "1" ||
        modulePermission.EditRec === "1" ||
        modulePermission.DeleteRec === "1" ||
        modulePermission.ViewRec === "1"
      );
    });
  };

  const handleOptionSelect = (event, newValue) => {
    if (newValue && newValue.route) {
      navigateToModule(newValue);
    }
    setSearchValue(newValue);
  };

  const navigateToModule = (module) => {
    if (!module || !module.route) return;
    
    // Check permissions
    if (permissions && permissions.length > 0) {
      const modulePermission = permissions.find(p => p.ModuleName === module.label);
      if (!modulePermission || (
        modulePermission.AddRec !== "1" &&
        modulePermission.EditRec !== "1" &&
        modulePermission.DeleteRec !== "1" &&
        modulePermission.ViewRec !== "1"
      )) {
        alert("You don't have permission to access this module");
        return;
      }
    }
    
    navigate(module.route);
    setSearchValue(null);
    handleVoiceClose();
  };

  const handleVoiceClick = (event) => {
    setAnchorEl(event.currentTarget);
    if (!isListening && recognition) {
      startListening();
    }
  };

  const handleVoiceClose = () => {
    setAnchorEl(null);
    if (isListening && recognition) {
      try {
        recognition.stop();
      } catch (e) {
        console.log('Error stopping recognition:', e);
      }
    }
    setIsListening(false);
    setIsProcessing(false);
    setTranscript('');
    setSuggestedModules([]);
    setErrorMessage('');
  };

  const startListening = () => {
    if (recognition && browserSupport) {
      setTranscript('');
      setErrorMessage('');
      setSuggestedModules([]);
      setIsListening(true);
      setIsProcessing(true);
      
      // Request microphone permission
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({ audio: true })
          .then(() => {
            setTimeout(() => {
              try {
                recognition.start();
                // Speak welcome message
                speakMessage("Which module would you like to search for? Please say the module name.");
              } catch (error) {
                console.error('Error starting recognition:', error);
                setIsListening(false);
                setIsProcessing(false);
                setErrorMessage('Could not start voice recognition. Please try again.');
              }
            }, 300);
          })
          .catch(err => {
            console.error('Microphone permission denied:', err);
            setIsListening(false);
            setIsProcessing(false);
            setErrorMessage('Microphone permission denied. Please allow microphone access.');
          });
      } else {
        try {
          recognition.start();
          speakMessage("Which module would you like to search for? Please say the module name.");
        } catch (error) {
          console.error('Error starting recognition:', error);
          setIsListening(false);
          setIsProcessing(false);
          setErrorMessage('Could not start voice recognition. Please try again.');
        }
      }
    } else {
      setErrorMessage('Voice search is not available. Please use text search.');
    }
  };

  const speakMessage = (message) => {
    if ('speechSynthesis' in window) {
      window.speechSynthesis.cancel();
      const speech = new SpeechSynthesisUtterance(message);
      speech.lang = 'en-IN';
      speech.rate = 0.9;
      speech.pitch = 1;
      speech.volume = 1;
      
      // Try to get Indian voice
      const voices = window.speechSynthesis.getVoices();
      const indianVoice = voices.find(voice => 
        voice.lang === 'en-IN' || 
        voice.name.includes('India') ||
        voice.name.includes('Indian')
      );
      
      if (indianVoice) {
        speech.voice = indianVoice;
      }
      
      window.speechSynthesis.speak(speech);
    }
  };

  // FIXED: Voice result handler with case-insensitive matching
  const handleVoiceResult = (voiceInput) => {
    if (!voiceInput || !voiceInput.trim()) {
      speakMessage("I didn't hear anything. Please try again.");
      setErrorMessage('No speech detected. Please try again.');
      setIsProcessing(false);
      return;
    }
    
    const normalizedInput = voiceInput.toLowerCase().trim();
    console.log('Voice input (normalized):', normalizedInput);
    
    const filteredOptions = getFilteredModuleOptions();
    
    // Find matches
    const matches = filteredOptions.map(option => {
      const moduleName = option.label.toLowerCase();
      let similarity = calculateSimilarity(normalizedInput, moduleName);
      
      // Check Indian variations
      if (option.indianVariations && option.indianVariations.length > 0) {
        option.indianVariations.forEach(variation => {
          const variationSimilarity = calculateSimilarity(normalizedInput, variation);
          if (variationSimilarity > similarity) {
            similarity = variationSimilarity;
          }
        });
      }
      
      // Check if input contains module name or vice versa
      if (normalizedInput.includes(moduleName) || moduleName.includes(normalizedInput)) {
        similarity = Math.max(similarity, 0.8);
      }
      
      return {
        module: option,
        similarity: similarity
      };
    }).filter(match => match.similarity > 0.6)
      .sort((a, b) => b.similarity - a.similarity);
    
    console.log('Matches found:', matches);
    
    setSuggestedModules(matches.slice(0, 5));
    
    if (matches.length > 0) {
      const bestMatch = matches[0];
      
      if (bestMatch.similarity > 0.75) {
        // High confidence match
        speakMessage(`Opening ${bestMatch.module.label}`);
        setTimeout(() => {
          navigateToModule(bestMatch.module);
        }, 800);
      } else {
        // Suggest options
        const suggestionText = matches.slice(0, 3)
          .map((m, i) => `${i + 1}. ${m.module.label}`)
          .join(', ');
        
        speakMessage(`Did you mean: ${suggestionText}? Click to select.`);
      }
    } else {
      // No matches found - try fuzzy search
      const fuzzyMatches = filteredOptions.filter(option => {
        const moduleName = option.label.toLowerCase();
        const words = normalizedInput.split(/\s+/);
        
        // Check if any word matches
        return words.some(word => 
          word.length > 2 && (
            moduleName.includes(word) || 
            option.indianVariations?.some(v => v.includes(word))
          )
        );
      }).slice(0, 3);
      
      if (fuzzyMatches.length > 0) {
        const suggestionText = fuzzyMatches.map(m => m.label).join(', ');
        speakMessage(`Did you mean: ${suggestionText}? Click to select.`);
        setSuggestedModules(fuzzyMatches.map(m => ({ module: m, similarity: 0.7 })));
      } else {
        speakMessage(`"${voiceInput}" not found. Please try typing the module name.`);
        setErrorMessage(`"${voiceInput}" not found. Try: Room Master, Property Master, Dashboard`);
        
        // Update search input
        setTimeout(() => {
          const inputElement = document.querySelector('.MuiAutocomplete-input');
          if (inputElement) {
            inputElement.value = voiceInput;
            const inputEvent = new Event('input', { bubbles: true });
            inputElement.dispatchEvent(inputEvent);
          }
        }, 100);
      }
    }
    
    setIsProcessing(false);
  };

  const handleSuggestionClick = (module) => {
    speakMessage(`Opening ${module.label}`);
    setTimeout(() => {
      navigateToModule(module);
    }, 500);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'voice-search-popover' : undefined;

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      mr: 2,
      width: 260,
    }}>
      <Autocomplete
        sx={{
          flexGrow: 1,
          '& .MuiOutlinedInput-root': {
            height: 35,
            backgroundColor: 'white',
            paddingLeft: '12px',
          },
          '& .MuiAutocomplete-input': {
            padding: '8.5px 4px !important',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#635bff',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#4a42d4',
          },
        }}
        options={getFilteredModuleOptions()}
        getOptionLabel={(option) => option.label}
        value={searchValue}
        onChange={handleOptionSelect}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            size="small"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: '#635bff' }} />
                  </InputAdornment>
                  {params.InputProps.startAdornment}
                </>
              ),
              endAdornment: (
                <>
                  <IconButton
                    size="small"
                    onClick={handleVoiceClick}
                    disabled={!browserSupport}
                    sx={{
                      padding: '4px',
                      color: isListening ? '#ff4444' : '#635bff',
                      '&:hover': {
                        backgroundColor: 'rgba(99, 91, 255, 0.1)',
                      }
                    }}
                  >
                    {isListening ? <MicOffIcon fontSize="small" /> : <MicIcon fontSize="small" />}
                  </IconButton>
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
            inputProps={{
              ...params.inputProps,
              placeholder: "Search or say module name"
            }}
          />
        )}
      />

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleVoiceClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        PaperProps={{
          sx: {
            p: 2,
            mt: 1,
            minWidth: 350,
            maxWidth: 450,
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <Box sx={{ position: 'relative' }}>
            <IconButton
              onClick={isListening ? () => {
                if (recognition) {
                  try {
                    recognition.stop();
                  } catch (e) {
                    console.log('Error stopping recognition:', e);
                  }
                }
                setIsListening(false);
              } : startListening}
              sx={{
                backgroundColor: isListening ? '#ff4444' : '#635bff',
                color: 'white',
                '&:hover': {
                  backgroundColor: isListening ? '#cc0000' : '#4a42d4',
                }
              }}
            >
              {isListening ? <MicOffIcon /> : <MicIcon />}
            </IconButton>
            {isListening && (
              <CircularProgress
                size={56}
                thickness={2}
                sx={{
                  color: '#635bff',
                  position: 'absolute',
                  top: -4,
                  left: -4,
                  zIndex: 1,
                }}
              />
            )}
          </Box>
          
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1" fontWeight="bold">
              Voice Search
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {isListening ? 'Listening... Speak now' : 'Click mic to start'}
            </Typography>
            
            {transcript && (
              <Typography variant="body2" sx={{ 
                mt: 1, 
                color: '#635bff',
                fontWeight: 500,
                fontStyle: 'italic'
              }}>
                You said: "{transcript}"
              </Typography>
            )}
            
            {isProcessing && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                <CircularProgress size={16} />
                <Typography variant="caption">Processing...</Typography>
              </Box>
            )}
            
            {errorMessage && (
              <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
                {errorMessage}
              </Typography>
            )}
          </Box>
        </Box>
        
        {suggestedModules.length > 0 && (
          <Box sx={{ mt: 2, borderTop: '1px solid #eee', pt: 2 }}>
            <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
              Did you mean?
            </Typography>
            <Stack direction="column" spacing={1}>
              {suggestedModules.map((match, index) => (
                <Chip
                  key={index}
                  label={match.module.label}
                  onClick={() => handleSuggestionClick(match.module)}
                  sx={{
                    justifyContent: 'flex-start',
                    borderRadius: '20px',
                    backgroundColor: '#e8e7ff',
                    border: '1px solid #635bff',
                    '&:hover': {
                      backgroundColor: '#635bff',
                      color: 'white',
                    }
                  }}
                  icon={<LanguageIcon />}
                />
              ))}
            </Stack>
          </Box>
        )}
        
        {/* <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #eee' }}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Indian Accent Tips
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            <Chip 
              label="Room = Rum" 
              size="small" 
              sx={{ backgroundColor: '#f0f0ff', fontSize: '0.75rem' }}
            />
            <Chip 
              label="Property = Proparty" 
              size="small" 
              sx={{ backgroundColor: '#f0fff0', fontSize: '0.75rem' }}
            />
            <Chip 
              label="Master = Mastar" 
              size="small" 
              sx={{ backgroundColor: '#fff0f0', fontSize: '0.75rem' }}
            />
          </Stack>
          
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
            Try saying: "रूम मास्टर", "प्रॉपर्टी मास्टर", "रुम मास्टर"
          </Typography>
        </Box> */}
        
        {!browserSupport && (
          <Typography variant="caption" color="error" sx={{ mt: 2, display: 'block' }}>
            Voice search requires Chrome, Edge, or Safari.
          </Typography>
        )}
      </Popover>
    </Box>
  );
};

export default SearchBoxWithVoice;